import React from 'react';
import DataStore from '../flux/stores/DataStore.js';
import Layout from './layout.js';
import Footer from './footer.js';

class Terms extends React.Component {
  render() {
    let terms = DataStore.getPageBySlug('privacy-statement');

    return (
      <div>
        <Layout>
          <section id="terms-section" className="terms-section">
            <div className="cnt">
              <div className="cnt one-third">
                <h1>Privacy Statement</h1>
                <div className="cross left top"><span className="vert"></span><span className="horiz"></span></div>
                <div className="cross left bottom"><span className="vert"></span><span className="horiz"></span></div>
                <div className="cross right top"><span className="vert"></span><span className="horiz"></span></div>
                <div className="cross right bottom"><span className="vert"></span><span className="horiz"></span></div>
              </div>
              <div className="cnt two-thirds">
                <div className="terms-content" dangerouslySetInnerHTML={{__html:terms.content.rendered}} />
                <div className="cross right top"><span className="vert"></span><span className="horiz"></span></div>
                <div className="cross right bottom"><span className="vert"></span><span className="horiz"></span></div>
                <div className="cross left top"><span className="vert"></span><span className="horiz"></span></div>
                <div className="cross left bottom"><span className="vert"></span><span className="horiz"></span></div>
              </div>

            </div>
          </section>
        </Layout>
        <Footer />
      </div>
    );
  }
}

export default Terms;



// WEBPACK FOOTER //
// ./src/scripts/components/terms.js